export const initialUserData = {
    cafeId: null,
    level: 0,
    totalExp: 0,
    kpiSchemeId: null,
    checklistId: null,
};

export const initialAdminData = {
    cafes: [],
    checklistId: null,
    cafeId: null,
    maxCountEmp: null,
    countOfCafes: 0,
    cafesLoading: false,
};

export const initialState = {
    userId: "",
    name: "",
    email: null,
    isActive: false,
    hasCredentials: false,
    profilePhotoUrl: null,
    userData: { ...initialUserData },
    adminData: { ...initialAdminData },
    loaded: false,
};
